module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title1))]), _vm._v(" "), _c('textarea', {
    attrs: {
      "placeholder": "type here"
    },
    domProps: {
      "value": _vm.ta1
    },
    on: {
      "keyup": function($event) {
        _vm.$emit('update:ta1', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title2))]), _vm._v(" "), _c('textarea', {
    attrs: {
      "placeholder": "type here"
    },
    domProps: {
      "value": _vm.ta2
    },
    on: {
      "keyup": function($event) {
        _vm.$emit('update:ta2', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title3))]), _vm._v(" "), _c('textarea', {
    attrs: {
      "placeholder": "type here"
    },
    domProps: {
      "value": _vm.ta3
    },
    on: {
      "keyup": function($event) {
        _vm.$emit('update:ta3', $event.target.value)
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-164770f6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MultiAnswer.vue
// module id = 988
// module chunks = 0